import {
  Component,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';

import { DetectTouchService } from '../../../services/detectTouch.serivce';
import { UploadWizardService } from '../wizard.service';
import { ImageViewerService } from '../../../shared/image-viewer/image-viewer.service';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'upload-wizard-design-style',
  styleUrls: ['../wizard.component.scss', './designStyle.component.scss'],
  templateUrl: './designStyle.component.html',
  animations: [
    trigger('item', [
      transition('void => *', [
        style({ opacity: 0 }),  // initial
        animate('0.5s',
          style({ opacity: 1 }))  // final
      ]),
    ]),
  ],
})
export class UploadWizardDesignStyleComponent {
  @ViewChild('coversContainer', { static: false }) private coversContainer;

  @Input() step;
  @Input() totalSteps;
  @Input() isMobile;
  @Input() projectId;
  @Input() isProjectUpdating;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();

  constructor(
    public uploadWizardService: UploadWizardService,
    private detectTouchService: DetectTouchService,
    public imageViewerService: ImageViewerService,
    private firebaseService: FirebaseService
  ) {}

  isOccasionSelected(occasion) {
    return this.uploadWizardService.specs.occasion === occasion;
  }

  selectOccasion(occasion?) {
    window.scrollTo(0, 0);
    this.uploadWizardService.isLoadingStyles = true;
    this.uploadWizardService.specs.occasion = occasion;
    this.uploadWizardService.getStyles(occasion);
    this.firebaseService.logEvent('design_request_occasion_select', {
      project_id: this.projectId,
      occasion: occasion,
    });
  }

  // getAllStyles() {
  //   this.uploadWizardService.getStyles();
  // }

  isStyleSelected(style) {
    return this.uploadWizardService.specs.style === style;
  }

  selectStyle(style) {
    this.uploadWizardService.specs.style = style;
  }

  currentImageIndex(style) {
    return style.currentImageIndex || 0;
  }

  isSlideLeftAvailable(style) {
    return this.currentImageIndex(style) > 0;
  }

  isSlideRightAvailable(style) {
    return (
      this.getStylePictureUrls(style).length > this.currentImageIndex(style) + 1
    );
  }

  getStylePictureUrls(style) {
    return Object.keys(style)
      .filter(field => field.startsWith('picture_'))
      .map(field => style[field]);
  }

  slideLeft(event, style) {
    if (!this.isSlideLeftAvailable(style)) {
      return;
    }
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    style.currentImageIndex = this.currentImageIndex(style) - 1;
  }

  slideRight(event, style) {
    if (!this.isSlideRightAvailable(style)) {
      return;
    }
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    style.currentImageIndex = this.currentImageIndex(style) + 1;
  }

  // Recalculate covers position on screen resize
  onResize(event) {}

  getCoversPosition(style) {
    const isMobile = window.innerWidth < 992;
    const defaultWidth = 400;
    let coverWidth = this.coversContainer
      ? this.coversContainer.nativeElement.children[0].width
      : defaultWidth;
    coverWidth = coverWidth || defaultWidth;
    const leftMargin = isMobile ? 4 : 70;
    const coverMargin = isMobile ? 24 : 60;

    return (
      leftMargin -
      (this.currentImageIndex(style) * coverWidth +
        coverMargin * this.currentImageIndex(style))
    );
  }

  isTouch() {
    return this.detectTouchService.isTouch();
  }

  zoom(event, style) {
    event.stopPropagation();
    this.imageViewerService.setImages(
      this.getStylePictureUrls(style),
      this.currentImageIndex(style)
    );
  }

  get isDesignOptionsApplied() {
    return this.uploadWizardService.designOptionsApplied;
  }

  submit() {
    if (this.isDesignOptionsApplied) {
      this.next.emit();
      this.firebaseService.logEvent('design_request_style_select', {
        project_id: this.projectId,
        style: this.uploadWizardService.specs.style,
      });
    }
  }
}
